import React from 'react'

import Scroller from 'components/Scroller'
import { Loader } from 'shared/ui'
import { withResizeChange } from 'util/hoc'

import styles from '../styles.css'

const Original = ({ height, children, hasMore, loadMore, isLoadingMore }) => {
  // Need to compute this in JS as cant use percentage on the Scroller max
  // height in CSS
  const headerHeight = 136
  const modalMargins = 40
  const maxHeight = height - headerHeight - modalMargins

  return (
    <Scroller
      style={{ maxHeight: `${maxHeight}px` }}
      loadMore={loadMore}
      hasMore={hasMore}
      loadingMore={isLoadingMore}
      loader={<Loader className={styles.loader} />}
    >
      {children}
    </Scroller>
  )
}

const ScrollPane = withResizeChange(({ width, height, ...rest }) => {
  return <Original {...rest} height={height} />
})

export default ScrollPane
